import { ILatLon } from "core/data/values/LatLon"
import { cells_to_xy, XY } from "../../dev/projection"


// copied from https://github.com/TheWorldSim/world-sim-data/blob/ed6d3ae/data/boundaries/eez/uk_eez.geojson
const UK_EEZ_COORDS_RAW: [number, number][] = [[-6.22,54.09],[-6.65,54.06],[-7.05,54.41],[-7.32,54.13],[-7.61,54.14],[-8.15,54.45],[-7.75,54.59],[-7.91,54.7],[-7.55,54.77],[-6.74,55.41],[-7.38,56.0],[-9.12,56.36],[-12.2,56.7],[-14.33,56.58],[-14.86,57.62],[-14.76,58.67],[-13.27,60.15],[-9.73,59.99],[-4.74,60.4],[-0.49,63.89],[1.79,61.36],[2.08,59.9],[1.48,58.43],[3.4,55.83],[2.76,54.38],[3.18,52.62],[1.89,51.2],[0.6,50.33],[-2.06,50.15],[-9.61,48.1],[-9.88,47.44],[-10.81,48.18],[-9.92,48.18],[-9.8,48.5],[-9.41,48.5],[-9.2,49.33],[-8.75,49.5],[-8.4,50.17],[-7.2,50.67],[-5.38,52.4],[-5.27,53.7],[-6.22,54.09]]
export const UK_EEZ_COORDS: ILatLon[] = UK_EEZ_COORDS_RAW
    .map(([lon, lat]) => ({ lat, lon }))


// Copied from https://github.com/TheWorldSim/world-sim-data/blob/40d84b0/data/dgg/uk_eez_h3_res_4.txt
const uk_eez_h3_res_4_csv = `h3 cell id (minus ffffffff), lat, lon, is land (L) or contains some land (l)
8409103,63.11,-1.34,
8409105,62.55,-1.55,
8409107,62.78,-1.06,
8409115,63.34,-0.84,
8409117,63.56,-0.34,
8409121,62.1,-0.52,
8409123,62.32,-0.04,
8409125,61.75,-0.26,
8409127,61.98,0.22,
8409129,62.21,-1.28,
840912b,62.44,-0.79,
840912d,61.87,-1.01,
8409131,62.89,0.19,
8409135,62.55,0.45,
8409139,63.0,-0.57,
840913b,63.22,-0.07,
840913d,62.66,-0.3,
8409161,62.08,-2.51,
8409163,62.32,-2.03,
8409165,61.74,-2.23,
8409167,61.98,-1.76,
8409a01,60.48,0.03,
8409a03,60.72,0.49,
8409a05,60.13,0.27,
8409a07,60.37,0.74,
8409a09,60.6,-0.69,l
8409a0b,60.83,-0.23,
8409a0d,60.25,-0.44,
8409a11,61.29,0.72,
8409a13,61.52,1.2,
8409a15,60.95,0.96,
8409a17,61.17,1.44,
8409a19,61.41,-0.01,
8409a1b,61.64,0.47,
8409a1d,61.06,0.25,
8409a21,59.66,1.21,
8409a23,59.9,1.67,
8409a25,59.31,1.44,
8409a27,59.54,1.9,
8409a29,59.78,0.51,
8409a2b,60.02,0.97,
8409a2d,59.43,0.75,
8409a31,60.48,1.91,
8409a39,60.6,1.2,
8409a3b,60.83,1.67,
8409a3d,60.25,1.44,
8409a41,60.46,-1.88,l
8409a43,60.71,-1.42,l
8409a45,60.12,-1.62,l
8409a47,60.36,-1.16,L
8409a49,60.57,-2.61,
8409a4b,60.81,-2.15,
8409a4d,60.22,-2.34,
8409a51,61.29,-1.21,
8409a53,61.52,-0.74,
8409a55,60.94,-0.95,l
8409a57,61.18,-0.48,
8409a59,61.4,-1.96,
8409a5b,61.63,-1.48,
8409a5d,61.05,-1.68,
8409a61,59.66,-0.65,
8409a63,59.9,-0.19,
8409a65,59.3,-0.4,
8409a67,59.54,0.06,
8409a69,59.76,-1.36,l
8409a6b,60.01,-0.9,l
8409a6d,59.41,-1.1,
8409ac9,62.21,0.7,
8409acd,61.86,0.95,
8409b01,58.0,1.66,
8409b05,57.64,1.88,
8409b09,58.12,0.99,
8409b0b,58.36,1.44,
8409b0d,57.76,1.22,
8409b19,58.95,1.67,
8409b29,57.28,2.09,
8409b2d,56.91,2.3,
8409b41,57.99,-0.12,
8409b43,58.23,0.32,
8409b45,57.63,0.11,
8409b47,57.87,0.55,
8409b49,58.1,-0.8,
8409b4b,58.35,-0.36,
8409b4d,57.74,-0.56,
8409b51,58.83,0.53,
8409b53,59.07,0.98,
8409b55,58.48,0.77,
8409b57,58.72,1.21,
8409b59,58.95,-0.15,
8409b5b,59.19,0.3,
8409b5d,58.59,0.08,
8409b61,57.15,1.0,
8409b63,57.4,1.44,
8409b65,56.79,1.22,
8409b67,57.03,1.66,
8409b69,57.27,0.34,
8409b6b,57.51,0.78,
8409b6d,56.9,0.57,
8418091,49.26,-8.37,
8418093,48.88,-8.11,
8418095,49.32,-9.0,
8418097,48.94,-8.73,
8418099,49.58,-8.02,
841809b,49.2,-7.75,
841809d,49.64,-8.64,
84180d1,50.28,-7.92,
84180d3,49.9,-7.66,
84180d7,49.96,-8.28,
84180db,50.22,-7.29,
8418211,54.06,-7.7,l
8418219,54.36,-7.31,L
841821d,54.42,-7.98,L
8418251,55.01,-7.2,L
8418253,54.65,-6.91,L
8418257,54.72,-7.59,L
8418259,55.31,-6.8,l
841825b,54.94,-6.52,L
8418291,51.45,-5.81,
8418293,51.07,-5.56,
8418297,51.15,-6.19,
8418299,51.75,-5.43,l
841829b,51.38,-5.18,
84182d1,52.43,-5.31,
84182d3,52.05,-5.05,l
84182d9,52.72,-4.92,
84182db,52.35,-4.67,
841854d,48.82,-7.49,
8418565,48.29,-9.43,
8418569,48.56,-8.46,
841856d,48.61,-9.08,
841864d,50.38,-0.69,
8418669,50.19,-1.66,
841866d,50.28,-2.26,
8418701,49.63,-5.19,
8418705,49.7,-5.8,
8418707,49.32,-5.55,
8418709,49.93,-4.82,
841870b,49.55,-4.58,
841870d,50.01,-5.43,l
8418721,49.46,-6.78,
8418723,49.08,-6.52,
8418725,49.52,-7.39,
8418727,49.14,-7.14,
8418729,49.77,-6.41,
841872b,49.39,-6.16,
841872d,49.84,-7.03,
8418741,50.62,-4.69,L
8418743,50.24,-4.45,l
8418745,50.7,-5.31,
8418747,50.31,-5.06,L
8418749,50.92,-4.31,L
841874b,50.54,-4.07,L
841874d,51.0,-4.93,
8418751,49.77,-3.6,
8418755,49.85,-4.21,
8418759,50.07,-3.23,
841875d,50.16,-3.84,l
8418761,50.46,-6.3,
8418763,50.08,-6.05,
8418765,50.53,-6.93,
8418767,50.15,-6.67,
8418769,50.77,-5.93,
841876b,50.39,-5.68,
841876d,50.84,-6.56,
8418e51,48.0,-10.39,
8418e5b,47.96,-9.77,
8419001,59.35,-8.26,
8419003,59.0,-7.94,
8419005,59.41,-9.01,
8419007,59.07,-8.69,
8419009,59.62,-7.83,
841900b,59.27,-7.51,
841900d,59.69,-8.59,
8419011,58.58,-6.9,
8419013,58.23,-6.6,L
8419015,58.65,-7.63,
8419017,58.3,-7.32,l
8419019,58.85,-6.47,
841901b,58.5,-6.17,l
841901d,58.93,-7.2,
8419021,59.2,-10.19,
8419023,58.85,-9.86,
8419025,59.25,-10.95,
8419027,58.91,-10.61,
8419029,59.48,-9.77,
841902b,59.13,-9.44,
841902d,59.54,-10.53,
8419031,58.44,-8.79,
8419033,58.09,-8.47,
8419035,58.51,-9.53,
8419037,58.16,-9.21,
8419039,58.72,-8.37,
841903b,58.37,-8.05,
841903d,58.79,-9.11,
8419043,59.89,-7.39,
8419047,59.96,-8.15,
841904b,60.16,-6.95,
8419051,59.47,-6.34,
8419053,59.12,-6.04,
8419055,59.55,-7.08,
8419057,59.2,-6.77,
8419059,59.73,-5.9,
841905b,59.38,-5.6,
841905d,59.81,-6.64,
8419063,59.76,-9.35,
8419067,59.82,-10.11,
841906b,60.03,-8.91,
8419081,56.88,-6.14,l
8419083,56.52,-5.86,L
8419085,56.96,-6.85,
8419087,56.6,-6.56,l
8419089,57.16,-5.73,l
841908b,56.8,-5.44,L
841908d,57.24,-6.43,L
8419091,56.08,-4.9,L
8419093,55.71,-4.63,L
8419095,56.16,-5.58,L
8419097,55.8,-5.31,l
8419099,56.35,-4.48,L
841909b,55.99,-4.22,L
841909d,56.44,-5.17,L
84190a1,56.75,-7.96,
84190a3,56.39,-7.67,
84190a5,56.81,-8.68,
84190a7,56.46,-8.37,
84190a9,57.03,-7.55,l
84190ab,56.68,-7.26,
84190ad,57.1,-8.27,
84190b1,55.96,-6.68,l
84190b3,55.59,-6.4,l
84190b5,56.03,-7.37,
84190b9,56.24,-6.27,l
84190bb,55.88,-5.99,l
84190bd,56.32,-6.97,
84190c1,57.79,-5.59,L
84190c3,57.43,-5.31,L
84190c5,57.87,-6.3,l
84190c7,57.52,-6.01,l
84190c9,58.06,-5.16,L
84190cb,57.71,-4.88,L
84190cd,58.15,-5.88,
84190d1,56.99,-4.33,L
84190d3,56.63,-4.06,L
84190d5,57.08,-5.03,L
84190d7,56.72,-4.75,L
84190d9,57.26,-3.91,L
84190db,56.9,-3.64,L
84190dd,57.35,-4.6,L
84190e1,57.67,-7.44,l
84190e3,57.32,-7.14,l
84190e5,57.74,-8.16,
84190e7,57.39,-7.86,
84190e9,57.95,-7.02,l
84190eb,57.6,-6.72,l
84190ed,58.02,-7.75,
8419101,59.73,-13.62,
8419103,59.4,-13.26,
8419109,60.02,-13.21,
841910b,59.69,-12.85,
8419111,59.01,-12.13,
8419113,58.67,-11.78,
8419115,59.06,-12.89,
8419117,58.72,-12.54,
8419119,59.3,-11.72,
841911b,58.96,-11.37,
841911d,59.35,-12.48,
8419131,58.8,-14.06,
8419133,58.46,-13.7,
8419137,58.5,-14.46,
8419139,59.1,-13.66,
841913b,58.76,-13.3,
8419151,59.93,-11.65,
8419153,59.59,-11.3,
8419155,59.98,-12.43,
8419157,59.64,-12.07,
841915b,59.88,-10.88,
8419181,57.34,-11.17,
8419183,56.99,-10.84,
8419185,57.39,-11.9,
8419187,57.04,-11.56,
8419189,57.64,-10.76,
841918b,57.29,-10.43,
841918d,57.69,-11.5,
8419191,56.58,-9.79,
8419195,56.64,-10.51,
8419199,56.88,-9.39,
841919b,56.52,-9.08,
841919d,56.94,-10.11,
84191a1,57.13,-13.03,
84191a3,56.79,-12.69,
84191a5,57.17,-13.77,
84191a7,56.83,-13.42,
84191a9,57.44,-12.64,
84191ab,57.09,-12.3,
84191ad,57.48,-13.38,
84191b9,56.69,-11.23,
84191bd,56.74,-11.96,
84191c1,58.28,-10.69,
84191c3,57.93,-10.36,
84191c5,58.33,-11.44,
84191c7,57.98,-11.1,
84191c9,58.57,-10.28,
84191cb,58.22,-9.95,
84191cd,58.62,-11.03,
84191d1,57.52,-9.3,
84191d3,57.17,-8.99,
84191d5,57.58,-10.03,
84191d7,57.23,-9.71,
84191d9,57.81,-8.89,
84191db,57.46,-8.58,
84191dd,57.87,-9.62,
84191e1,58.08,-12.59,
84191e3,57.74,-12.24,
84191e5,58.12,-13.34,
84191e7,57.78,-12.99,
84191e9,58.38,-12.19,
84191eb,58.04,-11.84,
84191ed,58.42,-12.94,
8419211,60.42,-3.81,
8419213,60.07,-3.53,
8419215,60.51,-4.55,
8419217,60.16,-4.26,
8419219,60.67,-3.35,
841921b,60.32,-3.07,
841921d,60.76,-4.1,
8419233,59.99,-5.45,
8419237,60.08,-6.2,
841923b,60.25,-5.01,
8419251,61.26,-3.17,
8419253,60.91,-2.89,
8419257,61.01,-3.64,
8419259,61.5,-2.71,
841925b,61.16,-2.43,
8419281,58.76,-3.15,l
8419283,58.41,-2.88,l
8419285,58.86,-3.86,
8419287,58.5,-3.59,L
8419289,59.02,-2.71,L
841928b,58.66,-2.44,
841928d,59.11,-3.42,l
8419291,57.95,-1.93,
8419293,57.59,-1.67,l
8419295,58.05,-2.62,
8419297,57.69,-2.36,l
8419299,58.2,-1.49,
841929b,57.84,-1.24,
841929d,58.31,-2.18,
84192a1,58.68,-5.02,l
84192a3,58.33,-4.73,L
84192a5,58.77,-5.74,
84192a7,58.42,-5.45,
84192a9,58.95,-4.58,
84192ab,58.59,-4.3,l
84192ad,59.03,-5.31,
84192b1,57.88,-3.75,l
84192b3,57.53,-3.48,L
84192b5,57.97,-4.45,L
84192b7,57.62,-4.18,L
84192b9,58.15,-3.32,l
84192bb,57.79,-3.05,l
84192bd,58.24,-4.02,L
84192c1,59.62,-2.53,
84192c3,59.27,-2.26,l
84192c5,59.72,-3.25,
84192c7,59.37,-2.97,l
84192c9,59.87,-2.07,
84192cb,59.52,-1.81,
84192cd,59.97,-2.8,
84192d1,58.81,-1.3,
84192d3,58.45,-1.05,
84192d5,58.92,-2.0,
84192d7,58.56,-1.74,
84192d9,59.06,-0.85,
84192db,58.7,-0.6,
84192dd,59.17,-1.55,
84192e1,59.56,-4.42,
84192e3,59.21,-4.14,
84192e5,59.65,-5.16,
84192e7,59.3,-4.87,
84192e9,59.82,-3.98,
84192eb,59.47,-3.7,
84192ed,59.91,-4.71,
8419401,53.65,0.21,l
8419403,53.28,0.43,l
8419405,53.76,-0.41,L
8419407,53.38,-0.19,L
8419409,53.92,0.62,
841940b,53.54,0.83,
841940d,54.03,-0.0,l
8419411,52.79,1.24,L
8419413,52.42,1.44,L
8419415,52.9,0.64,L
8419417,52.53,0.84,L
8419419,53.06,1.64,
841941b,52.68,1.84,l
841941d,53.17,1.04,
8419421,53.59,-1.44,L
8419423,53.21,-1.21,L
8419425,53.69,-2.07,L
8419427,53.31,-1.84,L
8419429,53.86,-1.03,L
841942b,53.49,-0.81,L
841942d,53.96,-1.67,L
8419431,52.74,-0.37,L
8419433,52.36,-0.16,L
8419435,52.84,-0.99,L
8419437,52.46,-0.77,L
8419439,53.01,0.03,L
841943b,52.63,0.24,L
841943d,53.11,-0.59,L
8419441,54.55,0.82,
8419443,54.18,1.03,
8419445,54.66,0.19,
8419447,54.29,0.41,
8419449,54.81,1.23,
841944b,54.44,1.44,
841944d,54.92,0.6,
8419451,53.69,1.85,
8419453,53.32,2.04,
8419455,53.81,1.24,
8419457,53.43,1.44,
8419459,53.95,2.25,
841945b,53.58,2.45,
841945d,54.07,1.64,
8419461,54.5,-0.85,L
8419463,54.13,-0.63,L
8419465,54.61,-1.49,L
8419467,54.23,-1.26,L
8419469,54.77,-0.44,
841946b,54.4,-0.22,l
841946d,54.87,-1.08,l
8419485,51.12,1.05,L
841948d,51.39,1.44,l
84194a1,50.94,0.08,L
84194a3,50.56,0.28,
84194a5,51.04,-0.52,L
84194a7,50.66,-0.31,l
84194a9,51.22,0.46,L
84194ab,50.84,0.66,l
84194ad,51.32,-0.13,L
84194c1,51.92,2.22,
84194c5,52.04,1.64,l
84194c7,51.66,1.83,
84194c9,52.19,2.62,
84194cd,52.3,2.03,
84194e1,51.88,0.65,L
84194e3,51.5,0.85,l
84194e5,51.98,0.05,L
84194e7,51.6,0.26,L
84194e9,52.15,1.04,L
84194eb,51.77,1.24,l
84194ed,52.25,0.45,L
8419501,54.33,-4.25,
8419503,53.96,-4.0,
8419505,54.42,-4.91,
8419507,54.05,-4.65,
8419509,54.61,-3.85,l
841950b,54.24,-3.6,l
841950d,54.7,-4.51,l
8419511,53.5,-3.1,l
8419513,53.13,-2.86,L
8419515,53.59,-3.75,
8419517,53.22,-3.5,L
8419519,53.78,-2.71,L
841951b,53.41,-2.47,L
841951d,53.87,-3.35,
8419521,54.21,-5.97,L
8419525,54.28,-6.64,L
8419529,54.5,-5.57,l
841952b,54.13,-5.31,
841952d,54.58,-6.24,L
8419531,53.39,-4.79,l
8419533,53.01,-4.53,l
8419537,53.1,-5.18,
8419539,53.68,-4.39,
841953b,53.3,-4.14,L
841953d,53.76,-5.04,
8419541,55.26,-3.7,L
8419543,54.89,-3.44,L
8419545,55.35,-4.36,L
8419547,54.98,-4.1,L
8419549,55.54,-3.29,L
841954b,55.17,-3.03,L
841954d,55.63,-3.95,L
8419551,54.43,-2.54,L
8419553,54.06,-2.3,L
8419555,54.52,-3.19,L
8419557,54.15,-2.95,L
8419559,54.7,-2.14,L
841955b,54.33,-1.9,L
841955d,54.8,-2.79,L
8419561,55.15,-5.44,
8419563,54.78,-5.17,l
8419565,55.23,-6.12,l
8419567,54.86,-5.84,L
8419569,55.43,-5.04,l
841956b,55.07,-4.77,L
841956d,55.52,-5.71,L
8419581,51.71,-2.55,L
8419583,51.33,-2.32,L
8419585,51.8,-3.17,L
8419587,51.42,-2.94,L
8419589,52.0,-2.16,L
841958b,51.62,-1.94,L
841958d,52.09,-2.78,L
8419591,50.86,-1.5,L
8419593,50.48,-1.28,l
8419595,50.95,-2.1,L
8419597,50.57,-1.88,l
8419599,51.14,-1.11,L
841959b,50.76,-0.9,l
841959d,51.24,-1.72,L
84195a1,51.59,-4.18,l
84195a3,51.21,-3.93,l
84195a5,51.67,-4.8,L
84195a7,51.3,-4.56,
84195a9,51.89,-3.79,L
84195ab,51.51,-3.55,L
84195ad,51.97,-4.42,L
84195b1,50.75,-3.09,L
84195b3,50.37,-2.86,
84195b5,50.84,-3.7,L
84195b7,50.45,-3.46,l
84195b9,51.04,-2.71,L
84195bb,50.66,-2.48,L
84195bd,51.13,-3.32,L
84195c1,52.66,-2.0,L
84195c3,52.28,-1.78,L
84195c5,52.75,-2.63,L
84195c7,52.37,-2.39,L
84195c9,52.94,-1.61,L
84195cb,52.56,-1.38,L
84195cd,53.03,-2.23,L
84195d1,51.8,-0.94,L
84195d3,51.43,-0.73,L
84195d5,51.9,-1.55,L
84195d7,51.52,-1.33,L
84195d9,52.08,-0.55,L
84195db,51.7,-0.34,L
84195dd,52.18,-1.16,L
84195e1,52.55,-3.65,L
84195e3,52.18,-3.41,L
84195e5,52.64,-4.28,l
84195e7,52.26,-4.04,L
84195e9,52.84,-3.26,L
84195eb,52.47,-3.02,L
84195ed,52.93,-3.89,L
8419601,55.45,3.11,
8419605,55.57,2.49,
8419607,55.2,2.69,
841960d,55.82,2.91,
8419621,55.44,1.44,
8419623,55.07,1.65,
8419625,55.55,0.81,
8419627,55.18,1.02,
8419629,55.69,1.86,
841962b,55.32,2.07,
841962d,55.81,1.23,
8419631,54.58,2.47,
8419633,54.21,2.67,
8419635,54.7,1.85,
8419637,54.32,2.06,
8419639,54.83,2.89,
841963d,54.95,2.27,
8419661,56.3,2.08,
8419663,55.94,2.29,
8419665,56.42,1.44,
8419667,56.06,1.65,
8419669,56.55,2.51,
841966b,56.18,2.71,
841966d,56.67,1.87,
84196a1,52.83,2.83,
84196a3,52.45,3.02,
84196a5,52.94,2.24,
84196a7,52.57,2.43,
84196ad,53.2,2.64,
84196e5,53.83,2.86,
8419701,56.24,-1.37,
8419703,55.88,-1.13,
8419705,56.34,-2.04,
8419707,55.98,-1.79,
8419709,56.5,-0.95,
841970b,56.14,-0.71,
841970d,56.61,-1.61,
8419711,55.4,-0.25,
8419713,55.03,-0.03,
8419715,55.51,-0.9,
8419717,55.14,-0.67,
8419719,55.66,0.17,
841971b,55.29,0.39,
841971d,55.77,-0.48,
8419721,56.17,-3.13,L
8419723,55.81,-2.87,L
8419725,56.27,-3.8,L
8419727,55.9,-3.54,L
8419729,56.44,-2.71,l
841972b,56.08,-2.46,l
841972d,56.54,-3.38,L
8419731,55.34,-1.97,L
8419733,54.98,-1.73,L
8419735,55.44,-2.62,L
8419737,55.07,-2.38,L
8419739,55.61,-1.55,l
841973b,55.24,-1.31,l
841973d,55.71,-2.21,L
8419741,57.12,-0.76,
8419743,56.76,-0.52,
8419745,57.23,-1.43,
8419747,56.87,-1.19,
8419749,57.38,-0.32,
841974b,57.01,-0.09,
841974d,57.48,-1.0,
8419751,56.29,0.37,
8419753,55.92,0.59,
8419755,56.4,-0.29,
8419757,56.03,-0.06,
8419759,56.54,0.79,
841975b,56.17,1.01,
841975d,56.65,0.14,
8419761,57.07,-2.54,L
8419763,56.71,-2.28,l
8419765,57.17,-3.22,L
8419767,56.8,-2.96,L
8419769,57.33,-2.11,L
841976b,56.97,-1.86,l
841976d,57.43,-2.79,L
8419a99,57.21,-14.51,
8419a9b,56.86,-14.15,
8419ad1,57.86,-14.49,
8419ad3,57.52,-14.12,
8419ad9,58.16,-14.09,
8419adb,57.82,-13.73,`

const UK_EEZ_H3_RES_4: Map<string, { land: boolean | "some" }> = new Map()

uk_eez_h3_res_4_csv.split("\n").slice(1).map(line =>
{
    const [short_h3r4_id, _lat, _lng, land] = line.split(",")
    const h3r4_id = short_h3r4_id + "ffffffff"

    UK_EEZ_H3_RES_4.set(h3r4_id!, { land: land === "L" ? true : land === "l" ? "some" : false })
})

export const H3R4_CELL_TO_XY: Map<string, XY> = cells_to_xy([...UK_EEZ_H3_RES_4.keys()])
